// src/store/mySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  userInfo: {},
  gpsLocation: null, // { latitude, longitude, accuracy }
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    updateUserInfo: (state, action) => {
      state.userInfo = { ...state.userInfo, ...action.payload };
    },
    setGpsLocation: (state, action) => {
      state.gpsLocation = action.payload; // { latitude, longitude, accuracy } or null
    },
  },
});

export const { setUserInfo, setToken, updateUserInfo, setGpsLocation } = userSlice.actions;

export default userSlice.reducer;
